import {EmailNotificationDto} from '../emailNotificationDto';
import {EditRequest} from '../../../app-common/data/requests/EditRequest';
import {Job} from '../job';

export class EditJobRequest extends EditRequest {
  job: Job;
  hasAssignee: boolean;
  hasCustomer: boolean;
  hasDueDate: boolean;
  emailNotifications: EmailNotificationDto;
}
